import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { Icon } from 'theme/icons/Icon';

const Index = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
`;

const Logo = styled.a`
    margin-top: 20px;
`;

const Title = styled.h1`
    line-height: 1;
`;

export const IndexPage = ({ title, info, link, logout }) => {
    return (
        <Index>
            <Title>{title}</Title>
            {info && <h2>{info}</h2>}
            {link && (
                <Link to="/login">
                    <h2>{link}</h2>
                </Link>
            )}
            {logout && (
                <Link to="/logout">
                    <h2>{logout}</h2>
                </Link>
            )}
            <Logo href="/">
                <Icon type="powerboard" />
            </Logo>
        </Index>
    );
};

export default IndexPage;
